<template>
  <v-card v-if="loading" class="map-dashboard__loading" flat>
    <h2 class="text-center">
      <v-progress-circular
          class="mr-2"
          color="primary"
          indeterminate
      ></v-progress-circular
      >
      Loading...
    </h2>
  </v-card>
  <v-card v-else class="map-dashboard" flat>
    <div class="map-dashboard__hero">
      <div class="map-dashboard__hero-text">
        <div class="map-dashboard__title">Map Dashboard</div>
        <div class="map-dashboard__subtitle">
          Explore provider and accreditor coverage by region in real time.
        </div>
      </div>
      <div class="map-dashboard__filters">
        <v-select
            v-model="typeOfLocation"
            :items="locationTypes"
            class="map-dashboard__select"
            dense
            hide-details
            label="Type of location"
            outlined
            prepend-inner-icon="mdi-map-marker"
            @input="loadMapData"
        ></v-select>
        <v-select
            v-if="showRegionSelect"
            v-model="selectedRegionId"
            :disabled="!typeOfLocation"
            :items="regions"
            class="map-dashboard__select"
            dense
            hide-details
            item-text="name"
            item-value="id"
            label="Region"
            outlined
            prepend-inner-icon="mdi-map"
            @input="loadMapData"
        ></v-select>
      </div>
    </div>
    <v-card class="map-dashboard__panel" flat :loading="mapLoading">
      <div class="map-dashboard__panel-header">
        <div class="map-dashboard__panel-title">{{ panelTitle }}</div>
        <div class="map-dashboard__panel-meta">
          <v-chip color="primary" outlined small>{{ locationCount }} locations</v-chip>
          <v-chip v-if="selectedRegionName" outlined small>{{ selectedRegionName }}</v-chip>
        </div>
      </div>
      <div id="map" class="map-dashboard__map"></div>
    </v-card>
  </v-card>
</template>

<script>
import "../../plugins/leaflet/leaflet.css";
import * as L from "leaflet";
import {MapService} from "./map.service";
import {MfrService} from '../Lookups/mfr/mfr.service';

export default {
  name: "MAP",
  components: {},
  data() {
    return {
      loading: false,
      expertLevel:
          localStorage.getItem("user") &&
          JSON.parse(localStorage.getItem("user")).data.expertLevels
              ? JSON.parse(localStorage.getItem("user")).data.expertLevels.code
              : "",
      regions: [],
      typeOfLocation: "",
      locationTypes: ["Accrediators", "CPD Providers"],
      selectedRegionId: null,
      mapLoading: false,
      mapLocations: [],
    };
  },
  computed: {
    showRegionSelect() {
      return this.expertLevel === "FED" || this.expertLevel === "REG";
    },
    selectedRegionName() {
      const match = this.regions.find(region => region.id === this.selectedRegionId);
      return match ? match.name : "";
    },
    panelTitle() {
      return this.typeOfLocation ? `${this.typeOfLocation} Coverage` : "Coverage Map";
    },
    locationCount() {
      return this.mapLocations.length;
    },
  },
  methods: {
    async updateMap(locationsList, type, regionZoom) {
      this.mapLocations = Array.isArray(locationsList) ? locationsList : [];
      const places = [{name: "Addis Ababa", coords: [9.005401, 38.763611]}];
      const center = places[0].coords;
      const zoom = regionZoom;
      if (L.DomUtil.get("map") !== undefined) {
        L.DomUtil.get("map")._leaflet_id = null;
      }
      const map = L.map("map", {attributionControl: false});

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {}).addTo(map);

      map.setView(center, zoom);

      const markerOptions = {
        radius: 12,
        stroke: true,
        fill: true,
        fillColor: "#2563eb",
        fillOpacity: 0.75,
      };

      this.mapLocations.map((c) =>
          L.circleMarker([+c.latitude, +c.longtiude], markerOptions)
              .addTo(map)
              .bindPopup(
                  type == "Accrediators"
                      ? `<div>
              
                <strong>Name - </strong> 
                ${c.accreditorName}
                  <br>
                  <strong>Accrediated on - </strong>
                  ${c.accreditationDate}
                  <br>
                  <strong>Email - </strong>
                  ${c.institutionalEmail}
                  <br>
                  <strong>Phone - </strong>
                  ${c.institutionalPhone}
                  <br> 
                  <strong>Status - </strong>
                  ${
                          c.isActive == true
                              ? "<span class='activeMarker'>Active</span>"
                              : "<span class='inActiveMarker'>Inactive</span>"
                      }
               
            <br/></div>`
                      : `<div>${c.trainingCenterName}</div>`
              )
      );
      this.mapLoading = false
    },
    async loadMapData() {
      if (!this.typeOfLocation) {
        return;
      }
      this.mapLoading = true;
      if (this.showRegionSelect) {
        if (!this.selectedRegionId) {
          this.mapLoading = false;
          return;
        }
        const locationsList = await MapService.getMapByRegion(
            this.selectedRegionId,
            this.typeOfLocation
        );
        this.updateMap(
            locationsList ? locationsList.data : [],
            this.typeOfLocation,
            12
        );
        return;
      }
      if (this.typeOfLocation === "Accrediators") {
        const accrediators = await MapService.getAccrediatorsMap();
        this.updateMap(accrediators.data, "Accrediators", 6);
        return;
      }
      if (this.typeOfLocation === "CPD Providers") {
        const cpdProviders = await MapService.getCpdProvidersMap();
        this.updateMap(cpdProviders.data, "CPD Providers", 6);
      }
    },
  },

  async mounted() {
    const res = await MfrService.getRegionsDrp();
    this.regions = res.data;
    if (!this.typeOfLocation) {
      this.typeOfLocation = this.locationTypes[1] || this.locationTypes[0] || "";
    }
    if (this.showRegionSelect && this.regions.length && !this.selectedRegionId) {
      this.selectedRegionId = this.regions[0].id;
    }
    this.loadMapData();
  },
};
</script>

<style scoped>
.map-dashboard {
  min-height: 100vh;
  padding: 24px;
  background: radial-gradient(circle at top, #f3f7fb 0%, #eef3f8 45%, #e8eef6 100%);
}

.map-dashboard__loading {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f8fc;
}

.map-dashboard__hero {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  margin-bottom: 20px;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

.map-dashboard__title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.map-dashboard__subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #6b7280;
}

.map-dashboard__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.map-dashboard__select {
  min-width: 220px;
}

.map-dashboard__panel {
  padding: 16px 20px 20px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.map-dashboard__panel-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.map-dashboard__panel-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.map-dashboard__panel-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.map-dashboard__map {
  height: 72vh;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #eef2f7;
}

.map-dashboard__select ::v-deep .v-input__slot {
  border-radius: 12px;
}
</style>
<style>.activeMarker {
  padding: 3px;
  font-weight: bold;
  color: white;
  background: green;
  border-radius: 5px;
}

.inActiveMarker {
  padding: 3px;
  font-weight: bold;
  color: white;
  background: rgb(199, 46, 8);
  border-radius: 5px;
}

.v-menu__content {
  z-index: 9999 !important;
}
</style>
